import { defineStore } from 'pinia';
import { routeToFilters } from '~/apps/pu-links/infrastructure/routeToFilters';
export var useSearchFiltersStore = defineStore('searchFilters', () => {
  var router = useRouter();
  var route = router.currentRoute;
  var filters = computed(() => routeToFilters(route));
  return {
    filters
  };
});